/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";

type ActiveSection = { title: string; level: 1 | 2 };

const StyleguideContext = createContext<{
  activeSection: ActiveSection | null;
  setActiveSection: Dispatch<SetStateAction<ActiveSection | null>>;
}>({
  activeSection: null,
  setActiveSection: () => {},
});

export const useStyleguideContext = ()=> {
  return useContext(StyleguideContext)
}

export type StyleguideProviderProps = {
  children: ReactNode;
};
export default function StyleguideProvider({ children }: StyleguideProviderProps) {
  const [activeSection, setActiveSection] = useState<ActiveSection | null>(null);

  return <StyleguideContext.Provider value={{ activeSection, setActiveSection }}>{children}</StyleguideContext.Provider>;
}
